import React from 'react';
import LocationPageTemplate from './LocationPageTemplate';

export default function FriscoPage() {
  return (
    <LocationPageTemplate
      city="Frisco"
      slug="frisco"
      neighborhoods="From Stonebriar to Phillips Creek Ranch, we know Frisco irrigation systems inside and out."
      localCopy={[
        "Frisco is one of the fastest-growing cities in the country, and irrigation systems here run hard from April through October to keep landscapes alive in the North Texas heat. We see everything from 1990s Hunter PGP rotors that need new nozzles to brand-new smart Rachio installs that need WiFi reconfiguration.",
        "Frisco's expansive clay soils crack pipes and shift sprinkler heads off-grade every summer. Our trucks carry full inventory for Rain Bird, Hunter, Toro, Irritrol, Weathermatic, Rachio and Irrigreen — most repairs are completed on the first visit with no waiting for parts.",
        "Frisco requires a backflow preventer on every irrigation system connected to city water. AAA Irrigation installs the backflow, coordinates the annual certification testing, and files the paperwork with the City of Frisco directly. One call handles compliance start to finish.",
      ]}
      reviewQuote="AAA Irrigation found a leak in our Stonebriar system that two other companies missed. Fast, honest, fair price. They are the only irrigation company we use now."
      reviewAuthor="Jennifer P. — Frisco, TX"
    />
  );
}
